module.exports = __webpack_public_path__ + "img/Frame_39.95d0a318.png";